import {
  DataTableSource,
  type DataTablePageOptions,
  type DataTablePageReq,
  type DataTablePageResp,
  type DataTableSourceOptions,
} from "@carbon6/c6-frontend-design";
import { listTrainingGpuQuotaRequests, type TrainingGpuQuotaRequestStatus } from "@/api";
import {
  createGpuQuotaRequestTableRows,
  type GpuQuotaRequestTableRow,
} from "./GpuQuotaRequestTableRow";
import { resolveGpuQuotaErrorMessage } from "./gpuQuotaFormat";

// 요청 이력 목록. 서버가 조직 스코프로 좁혀 최신순으로 보낸다. 페이지네이션이 없으므로(요청 수는
// 적다) 요청 page/size 는 무시하고 한 페이지로 만든다.
export class GpuQuotaRequestTableSource extends DataTableSource<GpuQuotaRequestTableRow> {
  // 켜면 운영자 대기열(pending)만 조회한다. 기본값은 전체 이력이다.
  private pendingOnly = false;
  // 값이 있으면 그 사람이 접수한 요청만 조회한다. 기준은 선점자가 아니라 행에 기록된 접수자다.
  private requestedByMemberUuid: string | undefined = undefined;

  constructor({
    // URL 에서 읽은 첫 조건. 첫 로드에 바로 적용한다. 그래서 initialize 뒤 setter 는 no-op 이 된다.
    initialPendingOnly = false,
    initialRequestedByMemberUuid = undefined,
    ...options
  }: DataTableSourceOptions & {
    initialPendingOnly?: boolean;
    initialRequestedByMemberUuid?: string | undefined;
  } = {}) {
    super({ resolveErrorMessage: resolveGpuQuotaErrorMessage, ...options });
    this.pendingOnly = initialPendingOnly;
    this.requestedByMemberUuid = initialRequestedByMemberUuid;
  }

  setPendingOnly(value: boolean): Promise<void> {
    if (value === this.pendingOnly) {
      return Promise.resolve();
    }
    this.pendingOnly = value;
    return this.goToPage(1);
  }

  setRequestedByMemberUuid(value: string | undefined): Promise<void> {
    if (value === this.requestedByMemberUuid) {
      return Promise.resolve();
    }
    this.requestedByMemberUuid = value;
    return this.goToPage(1);
  }

  protected override async onPage(
    req: DataTablePageReq,
    { signal }: DataTablePageOptions,
  ): Promise<DataTablePageResp<GpuQuotaRequestTableRow>> {
    const status: TrainingGpuQuotaRequestStatus | undefined = this.pendingOnly
      ? "pending"
      : undefined;
    const rows = createGpuQuotaRequestTableRows(
      await listTrainingGpuQuotaRequests(
        {
          status,
          requestedByMemberUuid: this.requestedByMemberUuid,
        },
        { signal },
      ),
    );
    return { rows, total: rows.length, page: 1, size: Math.max(rows.length, req.size) };
  }
}
